import IRootPageLink from '@/types/IRootPageLink';
import { Box, FormControl, Heading, Input, Text } from '@chakra-ui/react';
import RootPageLink from './components/RootPageLink';
import { MIN_NUMBER_OF_LINKS_REQUIRED_TO_DISPLAY_SEARCH, useRootPageTemplate } from './root-page.controller';

interface IProfilePageContentProps {
	name: string;
	description: string;
	links: Array<IRootPageLink>;
}

export default function RootPageContent(props: IProfilePageContentProps) {
	const { t, form, filteredLinks } = useRootPageTemplate(props);

	return (
		<Box flex="1" overflow="auto" maxH="100%" h="100dvh" background="white">
			<Box textAlign="center" pb="8" mb="12" mt="8" borderBottom="6px solid" borderColor="primary.500">
				<Heading>{props.name}</Heading>
				<Text fontSize="md" color="gray.800">
					{props.description}
				</Text>
			</Box>

			<Box maxW="md" margin="auto" px="4">
				{props.links.length > MIN_NUMBER_OF_LINKS_REQUIRED_TO_DISPLAY_SEARCH ? (
					<FormControl my={4}>
						<Input
							aria-label={t('Search')}
							placeholder={t('Search')}
							type="search"
							{...form.register('search')}
						></Input>
					</FormControl>
				) : null}
				{filteredLinks.map((link, index) => (
					<RootPageLink key={index} {...link} />
				))}
			</Box>
		</Box>
	);
}
